import { render, staticRenderFns } from "./navEdit.vue?vue&type=template&id=23165d3b"
import script from "./navEdit.vue?vue&type=script&lang=js"
export * from "./navEdit.vue?vue&type=script&lang=js"
import style0 from "./navEdit.vue?vue&type=style&index=0&id=23165d3b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports